export default "__VITE_ASSET__DT2emhJr__"